/*
 * Ficha de producto en tarjetas (ajuste "Mostrar precio y configuración en tarjetas").
 * - Marca el nivel de precio por volumen según la cantidad elegida.
 * - Al tocar un nivel, pone esa cantidad (respetando mínimos y múltiplos del producto).
 * - Cambia el precio grande, calcula el total estimado y dice cuánto falta para el siguiente nivel.
 * Los precios de cada nivel vienen ya calculados desde Liquid (snippets/volume-discounts.liquid).
 * No toca el precio nativo (#price-<section>), que siguen usando product-info.js y el cotizador.
 */
(function () {
  function init(container) {
    const sectionId = container.dataset.productCards;
    const input = () => document.getElementById(`Quantity-${sectionId}`);
    const tiersRoot = () => container.querySelector('[data-pc-tiers]');
    const total = container.querySelector('[data-pc-total]');

    function readTiers() {
      const root = tiersRoot();
      if (!root) return [];
      return Array.from(root.querySelectorAll('.pc-tier')).map((el) => ({
        el,
        qty: parseInt(el.dataset.qty, 10) || 1,
        cents: parseInt(el.dataset.cents, 10) || 0,
        money: el.dataset.money,
        disc: parseFloat(el.dataset.disc) || 0,
      }));
    }

    // Usa el formato de moneda de la tienda (prefijo/sufijo del precio ya formateado por Liquid).
    function formatter(sample) {
      const match = (sample || '').match(/^([^\d]*)[\d.,\s]*?([^\d]*)$/);
      const prefix = match ? match[1] : '$';
      const suffix = match ? match[2] : '';
      const number = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return (cents) => prefix + number.format(cents / 100) + suffix;
    }

    function currentQty() {
      const field = input();
      return Math.max(1, parseInt(field && field.value, 10) || 1);
    }

    function render() {
      const tiers = readTiers();
      const root = tiersRoot();
      if (!tiers.length || !root) {
        if (total) total.hidden = true;
        return;
      }

      const qty = currentQty();
      let index = 0;
      tiers.forEach((tier, i) => {
        if (qty >= tier.qty) index = i;
      });
      const active = tiers[index];
      const base = tiers[0];
      const money = formatter(base.money);

      tiers.forEach((tier, i) => {
        tier.el.classList.toggle('is-active', i === index);
        tier.el.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });

      const unit = root.querySelector('[data-pc-unit]');
      const was = root.querySelector('[data-pc-was]');
      if (unit) unit.textContent = active.money;
      if (was) was.hidden = active.disc <= 0;

      if (!total) return;
      total.hidden = false;
      total.querySelector('[data-pc-calc]').textContent =
        qty.toLocaleString('es-MX') + (qty === 1 ? ' pza' : ' pzs') + ' × ' + active.money;
      total.querySelector('[data-pc-amount]').textContent = money(active.cents * qty);

      const next = tiers[index + 1];
      const nudge = total.querySelector('[data-pc-nudge]');
      if (next) {
        nudge.textContent =
          'Agrega ' + (next.qty - qty).toLocaleString('es-MX') + ' pzs más y paga ' + next.money + ' c/u (−' + next.disc + '%)';
        nudge.hidden = false;
      } else {
        nudge.hidden = true;
      }
    }

    // Tocar un nivel: pone esa cantidad respetando el mínimo y el múltiplo del selector.
    container.addEventListener('click', (event) => {
      const tierEl = event.target.closest('.pc-tier');
      const field = input();
      if (!tierEl || !field) return;
      const step = parseInt(field.step, 10) || 1;
      const min = parseInt(field.dataset.min || field.min, 10) || 1;
      const wanted = parseInt(tierEl.dataset.qty, 10) || 1;
      field.value = Math.max(min, Math.ceil(wanted / step) * step);
      field.dispatchEvent(new Event('change', { bubbles: true }));
      render();
    });

    container.addEventListener('input', (event) => {
      if (event.target.id === `Quantity-${sectionId}`) render();
    });
    container.addEventListener('change', (event) => {
      if (event.target.id === `Quantity-${sectionId}`) render();
    });

    // Al cambiar de variante, product-info.js reemplaza la escalera (#Volume-<section>).
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (!event.data || event.data.sectionId === sectionId) setTimeout(render, 0);
      });
    }

    render();
  }

  function start() {
    document.querySelectorAll('[data-product-cards]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
